import api from "./api";

async function createBatch(name) {
  try {
    const response = await api.post(
      `api/batches`,
      {
        name,
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
}

async function getBatches() {
  try {
    const response = await api.get(
      `api/batches`
    );

    return response.data;
  } catch (error) {
    return [];
  }
}

async function getBatch(id) {
  try {
    const response = await api.get(
      `api/batches/${id}`
    );

    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  createBatch,
  getBatches,
  getBatch,
}